export default "__VITE_ASSET__BjYDuKg8__"